import React from 'react';
import { BadgeCheckIcon, BoxesIcon, TruckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const COLUMNS = [{
  title: 'Qui sommes-nous ?',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/f2132f8a-29a1-46bb-9d6d-88b913e7e444.jpg',
  imageAlt: 'Professionnelle souriante tenant une tranche de pastèque',
  icon: TruckIcon,
  content: 'LE PIAN DISTRIBUTION est votre grossiste partenaire, spécialisé dans l’approvisionnement des commerces, supermarchés et professionnels. Nous mettons notre expérience au service de vos besoins quotidiens.'
}, {
  title: 'Nos Produits',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d65f5af4-1e95-4b45-9cb6-d3acec5a493a.jpg',
  imageAlt: 'Assortiment de fruits et légumes frais',
  icon: BoxesIcon,
  content: 'Nous proposons une sélection variée, pensée pour répondre aux attentes des grandes et moyennes surfaces comme des commerces de proximité.',
  items: ['Alimentation : épicerie, frais, surgelés et fruits & légumes', 'Boissons et références festives', 'Maison, décoration et électronique']
}, {
  title: 'Pourquoi travailler avec nous ?',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/56cb6a67-1f99-404a-a68c-5fb7bc051d78.jpg',
  imageAlt: 'Panier de légumes frais transporté par des mains gantées',
  icon: BadgeCheckIcon,
  items: ['Prix compétitifs pour optimiser votre rentabilité', 'Large choix de références pour vos rayons', 'Approvisionnement rapide et service fiable']
}];
export function AboutSection() {
  return <section id="a-propos" className="w-full scroll-mt-20 bg-white" aria-labelledby="about-heading" data-id="element-9" data-mp="12ifb6yi2cne1">
      <div className="relative min-h-[300px] overflow-hidden bg-[#fcf0e5] sm:min-h-[360px]" data-id="element-10" data-mp="16iy46vvozzht">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/d93322d3-4ad8-41f4-92c8-3a35e30ac84c.jpg" alt="" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-11" data-mp="3n8d4v8yg9okk" />
        <div className="absolute inset-0 bg-[#fcf0e5]/35" data-id="element-12" data-mp="1xpoaxqjyyah5" />
        <div className="relative mx-auto flex min-h-[300px] max-w-7xl flex-col justify-center px-5 sm:min-h-[360px] lg:px-8" data-id="element-13" data-mp="1ss6c4szo1bmv">
          <p className="text-sm text-ardis-green/70" data-id="element-14" data-mp="1o04qwhkisakp">Accueil <span aria-hidden="true" data-id="element-15" data-mp="1nytmcfj92ysj">›</span> <span className="font-medium text-ardis-green" data-id="element-16" data-mp="1j2ms3k07vbqf">À propos de Nous</span></p>
          <h2 id="about-heading" className="mt-4 font-display text-4xl font-bold tracking-tight text-ardis-green sm:text-5xl lg:text-6xl" data-id="element-17" data-mp="1f088uysmy9ym">À Propos De Nous</h2>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 py-16 sm:py-20 lg:px-8" data-id="element-18" data-mp="1a3rjk19p9pjy">
        <h3 className="text-center font-display text-2xl font-bold text-ardis-blue sm:text-3xl" data-id="element-19" data-mp="152u0lmgv8rhe">Grossiste pour Supermarchés – Votre Partenaire en Approvisionnement</h3>
        <div className="mt-10 grid gap-10 md:grid-cols-3" data-id="element-20" data-mp="2zgl74d3wev8m">
          {COLUMNS.map((column, index) => {
          const Icon = column.icon;
          return <motion.article key={column.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.45,
            delay: index * 0.08
          }} data-id="element-21" data-mp="32y8y65h3png3" data-mpi={index}>
                <img src={column.image} alt={column.imageAlt} className="aspect-[4/3] w-full object-cover" data-id="element-22" data-mp="3gpe41pb2bbyv" />
                <div className="pt-6" data-id="element-23" data-mp="2jzwpeku3qfl1">
                  <div className="flex items-center gap-2" data-id="element-24" data-mp="2k0zdym3yc5xs">
                    <Icon className="h-5 w-5 text-ardis-yellow" aria-hidden="true" data-id="element-25" data-mp="2o0gmxpil7l7p" />
                    <h4 className="font-display text-xl font-bold text-ardis-blue" data-id="element-26" data-mp="2t0cq5mjgn8m7">{column.title}</h4>
                  </div>
                  {column.content && <p className="mt-4 text-sm leading-7 text-gray-600 sm:text-base" data-id="element-27" data-mp="2xzz27snjyitf">{column.content}</p>}
                  {column.items && <ul className="mt-4 space-y-2.5" aria-label={column.title} data-id="element-28" data-mp="8c8a5bc3trx6">
                      {column.items.map(item => <li key={item} className="flex gap-2 text-sm leading-6 text-gray-600 sm:text-base" data-id="element-29" data-mp="1m53vdyusa5i7">
                          <span className="mt-2 h-2 w-2 flex-shrink-0 rotate-45 bg-ardis-blue" aria-hidden="true" data-id="element-30" data-mp="1h7u6qlf7xxvf" />
                          <span data-id="element-31" data-mp="1v850pxbtrskt">{item}</span>
                        </li>)}
                    </ul>}
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}